import React from "react";
import { Share2, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  BackButton,
  Container,
  Content,
  Footer,
  HeroImage,
  Meta,
  ShareButton,
  Title,
  Wrapper,
} from "./LifeInsuranceIn2026";

const InvestmentStrategies = () => {
  const navigate = useNavigate();

  const blog = {
    title: "Top 5 Investment Strategies for Beginners",
    author: "Vijay M D",
    date: "March 18, 2026",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f",
  };

  const handleShare = async () => {
    const shareData = {
      title: blog.title,
      text: "Check out this article",
      url: window.location.href,
    };

    if (navigator.share) {
      await navigator.share(shareData);
    } else {
      await navigator.clipboard.writeText(shareData.url);
      alert("Link copied!");
    }
  };

  return (
    <Container>
      <Wrapper>
        <BackButton onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> Back
        </BackButton>

        <Title>{blog.title}</Title>
        <Meta>
          {blog.date} • {blog.author}
        </Meta>

        <HeroImage src={blog.image} />

        <Content>
          <p>
            Investing is one of the best ways to build long-term wealth. But for
            beginners, it can feel confusing and risky. The key is to start
            simple and stay consistent.
          </p>

          <h2>1. Start with SIPs</h2>
          <p>
            Systematic Investment Plans allow you to invest small amounts
            regularly, reducing risk and building discipline.
          </p>

          <h2>2. Diversify Your Portfolio</h2>
          <p>
            Don’t put all your money in one place. Spread investments across
            stocks, mutual funds, and safer options.
          </p>

          <h2>3. Think Long-Term</h2>
          <p>
            Markets go up and down. Long-term investing helps you ride out
            volatility and benefit from compounding.
          </p>

          <h2>4. Avoid Emotional Decisions</h2>
          <p>
            Fear and greed can lead to poor decisions. Stick to your plan and
            avoid panic buying or selling.
          </p>

          <h2>5. Keep Learning</h2>
          <p>
            Financial knowledge is your biggest asset. Stay updated and keep
            improving your investment strategy.
          </p>

          <h2>Final Thoughts</h2>
          <p>
            Investing is a journey, not a one-time decision. Start small, stay
            consistent, and let time do the magic.
          </p>
        </Content>

        <Footer>
          <ShareButton onClick={handleShare}>
            <Share2 size={18} /> Share
          </ShareButton>
        </Footer>
      </Wrapper>
    </Container>
  );
};

export default InvestmentStrategies;
